import classNames from 'classnames';
import { Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { Checkbox } from '@/components/ui/Checkbox';

interface FormItemWithCheckboxProps {
  name: string;
  value?: any;
  placeholder?: string;
  component: React.ComponentType<any>;
  label: string;
  data?: any[];
  onChangeParent?: (val: any) => void;
  inherited?: any;
  required?: boolean;
  checked?: boolean;
  isDisabled?: (field: string, isDisabled: boolean) => void;
  mode?: string;
}

const FormItemWithCheckbox: React.FC<FormItemWithCheckboxProps> = ({
  name,
  value,
  placeholder,
  component,
  label,
  data,
  onChangeParent,
  inherited,
  required,
}) => {
  const [checked, setChecked] = useState(!value);

  useEffect(() => {
    setChecked(!value);
  }, [value]);

  const handleCheck = () => {
    setChecked((checked) => !checked);
    onChangeParent?.(null);
  };

  return (
    <div className="flex items-center text-sm text-color8">
      <label
        htmlFor={name}
        className={classNames('flex w-1/3 truncate', {
          "before:content-['_*'] before:mr-1 before:text-red-500": required,
        })}
      >
        {label}
      </label>

      <div className="flex grow items-center gap-2">
        <Checkbox
          checked={checked}
          onCheckedChange={() => handleCheck()}
          data-testid={`form-checkbox-${name}`}
        />
        <div className="grow">
          <Field
            id={name}
            name={name}
            value={checked ? inherited : value}
            placeholder={placeholder}
            component={component}
            disabled={checked}
            data={data}
            onBlur={(_e: React.FocusEvent) => {}}
          />
        </div>
      </div>
    </div>
  );
};

export default FormItemWithCheckbox;
